import React from 'react';
import './simplecarousel.scss'

export default class SimpleCarousel extends React.Component {
	
	constructor(props){
		super(props);

		this.timer = setInterval(()=>{});

		this.state = {
			index : 0,
			transition : true
		}
	}

	componentDidMount(){
		this.setState({transition : false});
		this.startTimer();
	}

	componentWillUnmount(){

	}

	render(){
		return 	<div className="component simplecarousel" data-transition={this.state.transition}>
					{this.props.items.map((url, i) => {
						return <img key={i} src={url} data-visible={i === this.state.index} alt=""/>
					})}
					
				</div>
	}

	startTimer(){
		this.timer = setInterval(()=>{
			this.switch()
		}, this.props.timeout || 10000)
	}

	switch(){
		this.setState({transition : true}, ()=>{
			this.timer = setTimeout(()=>{

				this.setState({
					index : this.state.index >= this.props.items.length - 1 ? 0 : this.state.index + 1,
					transition : false
				})

			}, 400)
			
		})
	}
}



// WEBPACK FOOTER //
// ./src/components/simplecarousel/simplecarousel.jsx